import { GetOpenEnrollmentRule } from "../../form-wrappers/family-form/types/qualifying-life-event.response.interface";

export enum SEP_CIRCUMSTANCE_ID {
    //Generic Events
    //HM & MN
    ICHRA = "ICHRA",
    QSEHRA = "QSEHRA",
    // MN & WY
    BIRTH = "BIRTH",
    ADOPTION = "ADOPTION",
    MARRIAGE = "MARRIAGE",
    DEATH_POLICYHOLDER = "DEATH_POLICYHOLDER",
    LOSS_OF_MEDICAID = "LOSS_OF_MEDICAID",
    LEGAL_SEPARATION = "LEGAL_SEPARATION",

    //HM & WY
    LOSS_OF_COVERAGE = "LOSS_OF_COVERAGE",

    //HM Events
    NEW_ENROLLEE = "NEW_ENROLLEE",
    COURT_ORDER = "COURT_ORDER",
    DV_OR_ABANDONMENT = "DV_OR_ABANDONMENT",
    MEDICAID_OR_CHIP_DENIAL = "MEDICAID_OR_CHIP_DENIAL",
    
    // MN Events
    FOSTER_CARE = "FOSTER_CARE",
    COURT_ORDER_MN = "COURT_ORDER_MN",
    PREGNANCY = "PREGNANCY",
    LOSS_OF_COVERAGE_EMPLOYER = "LOSS_OF_COVERAGE_EMPLOYER",
    LOSS_OF_COVERAGE_BENEFIT = "LOSS_OF_COVERAGE_BENEFIT",
    MEDICARE_ENTITLED = "MEDICARE_ENTITLED",
    LOSS_CHILD_DEPENDENT = "LOSS_CHILD_DEPENDENT",
    LOSS_OF_COBRA = "LOSS_OF_COBRA",
    MOVING_OUT_HMO = "MOVING_OUT_HMO",
    RESIDENCE_CHANGE = "RESIDENCE_CHANGE",
    RELEASE_INCARCERATION = "RELEASE_INCARCERATION",
    MILITARY_SERVICE = "MILITARY_SERVICE",
    FINANCIAL_CHANGE = "FINANCIAL_CHANGE", 
    //WY Events 
    LEGAL_GUARDIANSHIP = "LEGAL_GUARDIANSHIP",
    OTHER = "OTHER"
}

export const submittedAttemptProxyConnectPath = "PROXY:payloadStates:special-enrollment-circumstance:submitAttempted";
export const defaultApplicableCircumstanceConnectPath = "PROXY:payloadStates:special-enrollment-circumstance:isApplicableCircumstance";
export const defaultLifeEventProxyConnectPath = "PROXY:payloadStates:special-enrollment-circumstance:lifeEvent";
export const defaultDateOfLifeEventProxyConnectPath = "PROXY:payloadStates:special-enrollment-circumstance:submitAttempted";

export interface SpecialEnrollmentCircumstance {
    dateOfLifeEvent: string;
    isApplicableCircumstance: 'Yes' | 'No';
    lifeEvent: GetOpenEnrollmentRule;
}